export default __webpack_public_path__ + "static/media/blueCircleTick.21bae3f2.svg";